/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AccountCodeExtended,
    AccountCodeExtendedFromJSON,
    AccountCodeExtendedFromJSONTyped,
    AccountCodeExtendedToJSON,
    GeoFormData,
    GeoFormDataFromJSON,
    GeoFormDataFromJSONTyped,
    GeoFormDataToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchSubRuleFormData
 */
export interface SearchSubRuleFormData {
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof SearchSubRuleFormData
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleFormData
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleFormData
     */
    ruleId?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleFormData
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchSubRuleFormData
     */
    maxPriceSolutions?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchSubRuleFormData
     */
    maxPricePoints?: number | null;
    /**
     * 
     * @type {object}
     * @memberof SearchSubRuleFormData
     */
    maxConnectionTime?: object | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof SearchSubRuleFormData
     */
    preferredCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof SearchSubRuleFormData
     */
    prohibitedCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof SearchSubRuleFormData
     */
    permittedCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleFormData
     */
    excludeBaglessFares?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleFormData
     */
    excludeDoubleConnections?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleFormData
     */
    directFlightsOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleFormData
     */
    restrictMultiAirportConnections?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleFormData
     */
    restrictMultiSectorSearch?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchSubRuleFormData
     */
    fareTypes?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SearchSubRuleFormData
     */
    fareSubtypes?: { [key: string]: string; } | null;
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleFormData
     */
    accountCode?: string | null;
    /**
     * 
     * @type {Array<AccountCodeExtended>}
     * @memberof SearchSubRuleFormData
     */
    accountCodes?: Array<AccountCodeExtended> | null;
    /**
     * 
     * @type {Array<GeoFormData>}
     * @memberof SearchSubRuleFormData
     */
    undesirableConnectionPoints?: Array<GeoFormData> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleFormData
     */
    excludeUpSell?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleFormData
     */
    channelId?: string | null;
}

export function SearchSubRuleFormDataFromJSON(json: any): SearchSubRuleFormData {
    return SearchSubRuleFormDataFromJSONTyped(json, false);
}

export function SearchSubRuleFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSubRuleFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'ruleId': !exists(json, 'ruleId') ? undefined : json['ruleId'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'maxPriceSolutions': !exists(json, 'maxPriceSolutions') ? undefined : json['maxPriceSolutions'],
        'maxPricePoints': !exists(json, 'maxPricePoints') ? undefined : json['maxPricePoints'],
        'maxConnectionTime': !exists(json, 'maxConnectionTime') ? undefined : json['maxConnectionTime'],
        'preferredCarriers': !exists(json, 'preferredCarriers') ? undefined : (json['preferredCarriers'] === null ? null : (json['preferredCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'prohibitedCarriers': !exists(json, 'prohibitedCarriers') ? undefined : (json['prohibitedCarriers'] === null ? null : (json['prohibitedCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'permittedCarriers': !exists(json, 'permittedCarriers') ? undefined : (json['permittedCarriers'] === null ? null : (json['permittedCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'excludeBaglessFares': !exists(json, 'excludeBaglessFares') ? undefined : json['excludeBaglessFares'],
        'excludeDoubleConnections': !exists(json, 'excludeDoubleConnections') ? undefined : json['excludeDoubleConnections'],
        'directFlightsOnly': !exists(json, 'directFlightsOnly') ? undefined : json['directFlightsOnly'],
        'restrictMultiAirportConnections': !exists(json, 'restrictMultiAirportConnections') ? undefined : json['restrictMultiAirportConnections'],
        'restrictMultiSectorSearch': !exists(json, 'restrictMultiSectorSearch') ? undefined : json['restrictMultiSectorSearch'],
        'fareTypes': !exists(json, 'fareTypes') ? undefined : json['fareTypes'],
        'fareSubtypes': !exists(json, 'fareSubtypes') ? undefined : json['fareSubtypes'],
        'accountCode': !exists(json, 'accountCode') ? undefined : json['accountCode'],
        'accountCodes': !exists(json, 'accountCodes') ? undefined : (json['accountCodes'] === null ? null : (json['accountCodes'] as Array<any>).map(AccountCodeExtendedFromJSON)),
        'undesirableConnectionPoints': !exists(json, 'undesirableConnectionPoints') ? undefined : (json['undesirableConnectionPoints'] === null ? null : (json['undesirableConnectionPoints'] as Array<any>).map(GeoFormDataFromJSON)),
        'excludeUpSell': !exists(json, 'excludeUpSell') ? undefined : json['excludeUpSell'],
        'channelId': !exists(json, 'channelId') ? undefined : json['channelId'],
    };
}

export function SearchSubRuleFormDataToJSON(value?: SearchSubRuleFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'id': value.id,
        'allowEdit': value.allowEdit,
        'disabled': value.disabled,
        'ruleId': value.ruleId,
        'description': value.description,
        'maxPriceSolutions': value.maxPriceSolutions,
        'maxPricePoints': value.maxPricePoints,
        'maxConnectionTime': value.maxConnectionTime,
        'preferredCarriers': value.preferredCarriers === undefined ? undefined : (value.preferredCarriers === null ? null : (value.preferredCarriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'prohibitedCarriers': value.prohibitedCarriers === undefined ? undefined : (value.prohibitedCarriers === null ? null : (value.prohibitedCarriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'permittedCarriers': value.permittedCarriers === undefined ? undefined : (value.permittedCarriers === null ? null : (value.permittedCarriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'excludeBaglessFares': value.excludeBaglessFares,
        'excludeDoubleConnections': value.excludeDoubleConnections,
        'directFlightsOnly': value.directFlightsOnly,
        'restrictMultiAirportConnections': value.restrictMultiAirportConnections,
        'restrictMultiSectorSearch': value.restrictMultiSectorSearch,
        'fareTypes': value.fareTypes,
        'fareSubtypes': value.fareSubtypes,
        'accountCode': value.accountCode,
        'accountCodes': value.accountCodes === undefined ? undefined : (value.accountCodes === null ? null : (value.accountCodes as Array<any>).map(AccountCodeExtendedToJSON)),
        'undesirableConnectionPoints': value.undesirableConnectionPoints === undefined ? undefined : (value.undesirableConnectionPoints === null ? null : (value.undesirableConnectionPoints as Array<any>).map(GeoFormDataToJSON)),
        'excludeUpSell': value.excludeUpSell,
        'channelId': value.channelId,
    };
}


